import * as STD     from '@emersya/mpa-std-lib';
import EngineModule from '../../../EngineModule';
import {
	NS as StandingHighSignNS
}                   from '../../../components/customers/standing/StandingHighSign/StandingHighSign';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-highSign',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor'
	],
	modulesAfter :     [
		'viewer-planner-furniture-editor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : {
		type : 'or',
		LHS :  {
			type :      'equal',
			component : 'K',
			property :  'TARGET.currentProduct.reference.value',
			value :     'prestige'
		},
		RHS :  {
			type :      'equal',
			component : 'K',
			property :  'TARGET.currentProduct.reference.value',
			value :     'business'
		}
	},
	generateComponentConfiguration() : StandingHighSignNS.Configuration {
		if (!this.translations.text || !this.translations.textGraphic) {
			throw STD.errors.user('');
		}
		return {
			text : this.translations.text,
			forceBackgroundColor : '',
			textGraphic : this.translations.textGraphic
		};
	},
	async initialize() {
	}
});
